export default { // in use

    methods: {
        createBarData(arr, type, country){
        
            //console.log(type) ;

            if (!Array.isArray(arr)) {
                console.log("parameter is not an array");
                return null;
            }
            if (arr.length > 0) {
                if(!('landcode' in arr[0])){
                    console.log("array elements have completely unknown composition");
                    return null;
                } else {
                    for (let i = 0; i < arr.length; i++){
                        // find the selected country array 
                        if(arr[i].landcode === country){
                            arr = arr[i].availability;
                        }
                    }                    
                }
            }

            let xvalues = [], yvalues = [], barcolors = [], barhovercolors = [];
            
            for (let i = 0; i < arr.length; i++){
                if(i < (arr.length - 1)) { // split description or it will be a marketing reference only
                    let desc = arr[i].marketing_level_desc.split(",");                
                    xvalues.push(desc[0]);
                }else {
                    xvalues.push(arr[i].marketing_level_desc);
                }
                yvalues.push(arr[i].number_of_houses);
                switch(i){
                    case 1:
                        barcolors.push('rgba(255, 99, 132, 0.7)');
                        barhovercolors.push('rgba(255, 99, 132, 1)');
                        break;
                    case 2:
                        barcolors.push('rgba(255, 159, 64, 0.7)');
                        barhovercolors.push('rgba(255, 159, 64, 1)');
                        break;
                    case 3:
                        barcolors.push('rgba(255, 206, 86, 0.7)');
                        barhovercolors.push('rgba(255, 206, 86, 1)');
                        break;
                    case 4: 
                        barcolors.push('rgba(75, 192, 192, 0.7)');
                        barhovercolors.push('rgba(75, 192, 192, 1)');
                        break;
                    case 5: 
                        barcolors.push('rgba(54, 162, 235, 0.7)');
                        barhovercolors.push('rgba(54, 162, 235, 1)');
                        break;
                    case 6: 
                        barcolors.push('rgba(50, 205, 50, 0.7)');
                        barhovercolors.push('rgba(50, 205, 50, 1)');
                        break;                        
                    default: // 0 and all other levels that may be added
                        barcolors.push('rgba(153, 102, 255, 0.7)');
                        barhovercolors.push('rgba(153, 102, 255, 1)');
                }                
            }

            //console.log(JSON.stringify(yvalues));

            let datasets = [];
            let dataset_element = {
                "backgroundColor": barcolors,
                "hoverBackgroundColor": barhovercolors,   
                "data": yvalues,
                "borderColor": "#006400",
                "hoverBorderColor": barhovercolors,     
                "borderWidth": 2,
            };
            datasets.push(dataset_element);

            if (type === "bar") {
                xvalues = xvalues.reverse();
                yvalues = yvalues.reverse();
                barcolors = barcolors.reverse();
            }

            let xdata = {
                "labels": xvalues,
                "datasets": datasets,
            };

            let xtitle = {
                "display": true,
                "text": "Availability by marketing level",
            };
            
            let xlegend = {
                "legend": {
                    "display": true, 
                    "position": "right"
                },
                datalabels: {
                    formatter: function(value, context){
                        return context !== null ? value === 0 ? '' : '': '';                         
                    }
                }                   
            };

            let xoptions = {
                "plugins": xlegend,
                "title": xtitle,
                "responsive": true,
                "maintainAspectRatio": false,
                "lineTension": 1,
            };
             
            let chartData = {
                "type": type,
                "data": xdata,
                "options": xoptions,
            };
            //console.log(JSON.stringify(chartData));
            return chartData;

        }                
    }
}